// import React, { useState, useEffect } from "react";
// import api from "../api/axios";
// import toast from "react-hot-toast";
// import { BookOpen, Award, Clock, ChevronRight } from "lucide-react";

// export default function Quiz() {
//   const [selectedProvider, setSelectedProvider] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [history, setHistory] = useState([]);
//   const [quizStarted, setQuizStarted] = useState(false);
  
//   // For testing multiple users
//   const [testUser, setTestUser] = useState({
//     id: 'user1',
//     name: 'John Doe'
//   });

//   const loadHistory = async () => {
//     try {
//       const res = await api.get(`/quiz/my?testUserId=${testUser.id}`);
//       setHistory(res.data || []);
//     } catch (err) {
//       console.error("Quiz history loading failed (non-critical):", err.message);
//       // Set empty history instead of throwing error
//       setHistory([]);
//     }
//   };

//   useEffect(() => {
//     loadHistory();
//   }, [testUser.id]); // Reload when test user changes

//   const selectProvider = async (provider) => {
//     setSelectedProvider(provider);
//     setLoading(true);
//     setAnswers({});
    
//     try {
//       const res = await api.get(`/quiz/questions/${provider}`);
//       setQuestions(res.data.questions || []);
//       setQuizStarted(true);
//       toast.success(`${provider} quiz loaded! ${res.data.questions?.length || 0} questions`);
//     } catch (err) {
//       const msg = err.response?.data?.message || `Failed to load ${provider} quiz`;
//       toast.error(msg);
//       setSelectedProvider(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const pick = (qIdx, opt) => {
//     setAnswers((prev) => ({ ...prev, [qIdx]: opt }));
//   };

//   const submit = async () => {
//     const total = questions.length;
//     let correctCount = 0;
    
//     questions.forEach((q, idx) => {
//       if (answers[idx] === q.correct) correctCount += 1;
//     });

//     // Calculate points: 10 per correct + 30 bonus if all correct
//     let points = correctCount * 10;
//     if (correctCount === total) {
//       points += 30;
//     }

//     setSubmitting(true);
//     try {
//       const res = await api.post("/quiz/submit", {
//         provider: selectedProvider,
//         correct: correctCount,
//         total,
//         calculatedPoints: points,
//         testUserId: testUser.id,
//         testUserName: testUser.name
//       });
      
//       const earnedPoints = res.data.points || points;
//       const bonusText = correctCount === total ? " (including 30 bonus for perfect score!)" : "";
      
//       toast.success(`Quiz completed! ${correctCount}/${total} correct. Earned ${earnedPoints} XP${bonusText}`);
      
//       // Reset quiz
//       setAnswers({});
//       setQuizStarted(false);
//       setSelectedProvider(null);
//       setQuestions([]);
//       loadHistory();
//     } catch (err) {
//       const msg = err.response?.data?.message || "Quiz submission failed";
//       toast.error(msg);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const resetQuiz = () => {
//     setQuizStarted(false);
//     setSelectedProvider(null);
//     setQuestions([]);
//     setAnswers({});
//   };

//   // Show provider selection screen
//   if (!quizStarted) {
//     return (
//       <div className="container-fluid">
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             <div className="card" style={cardStyle}>
//               <div className="text-center mb-4">
//                 <BookOpen size={48} color="#82c8ff" className="mb-3" />
//                 <h3 style={{ color: "#eaf6ff", fontWeight: 700 }}>Weekly Quiz Arena</h3>
//                 <p style={{ color: "#8ecbff", fontSize: 16 }}>
//                   Test your cloud knowledge and earn XP! Select a provider to begin.
//                 </p>
//               </div>

//               {/* Test User Selector (for testing multiple users) */}
//               <div className="mb-4 p-3" style={{ 
//                 background: "rgba(130,200,255,0.1)", 
//                 borderRadius: 10, 
//                 border: "1px solid rgba(130,200,255,0.2)" 
//               }}>
//                 <div className="row align-items-center">
//                   <div className="col-md-6">
//                     <label style={{ color: "#eaf6ff", fontSize: 14, marginBottom: 8 }}>
//                       👤 Test User (for demo):
//                     </label>
//                     <select 
//                       className="form-select form-select-sm"
//                       value={testUser.id}
//                       onChange={(e) => {
//                         const selected = [
//                           {id: 'user1', name: 'John Doe'},
//                           {id: 'user2', name: 'Jane Smith'},
//                           {id: 'user3', name: 'Alice Johnson'},
//                           {id: 'user4', name: 'Bob Wilson'}
//                         ].find(u => u.id === e.target.value);
//                         setTestUser(selected);
//                       }}
//                       style={{ 
//                         background: "rgba(3,19,40,0.8)", 
//                         border: "1px solid rgba(130,200,255,0.3)",
//                         color: "#eaf6ff"
//                       }}
//                     >
//                       <option value="user1">John Doe (user1)</option>
//                       <option value="user2">Jane Smith (user2)</option>
//                       <option value="user3">Alice Johnson (user3)</option>
//                       <option value="user4">Bob Wilson (user4)</option>
//                     </select>
//                   </div>
//                   <div className="col-md-6">
//                     <div style={{ color: "#8ecbff", fontSize: 12, marginTop: 8 }}>
//                       <strong>Quizzes Taken:</strong> {history.length}<br />
//                       <strong>Current User:</strong> {testUser.name}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row g-4">
//                 <div className="col-md-6">
//                   <div 
//                     className="quiz-provider-card"
//                     onClick={() => !loading && selectProvider('AWS')}
//                     style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
//                   >
//                     <div className="d-flex align-items-center justify-content-between">
//                       <div>
//                         <h5 style={{ color: "#eaf6ff", margin: 0 }}>🚀 AWS Quiz</h5>
//                         <p style={{ color: "#8ecbff", margin: "8px 0 0 0", fontSize: 14 }}>
//                           Amazon Web Services certification topics
//                         </p>
//                       </div>
//                       <ChevronRight size={24} color="#82c8ff" />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <div 
//                     className="quiz-provider-card"
//                     onClick={() => !loading && selectProvider('Azure')}
//                     style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
//                   >
//                     <div className="d-flex align-items-center justify-content-between">
//                       <div>
//                         <h5 style={{ color: "#eaf6ff", margin: 0 }}>☁️ Azure Quiz</h5>
//                         <p style={{ color: "#8ecbff", margin: "8px 0 0 0", fontSize: 14 }}>
//                           Microsoft Azure certification topics
//                         </p>
//                       </div>
//                       <ChevronRight size={24} color="#82c8ff" />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-4 p-3" style={{ 
//                 background: "rgba(130,200,255,0.1)", 
//                 borderRadius: 10, 
//                 border: "1px solid rgba(130,200,255,0.2)" 
//               }}>
//                 <div className="d-flex align-items-center mb-2">
//                   <Award size={20} color="#82c8ff" className="me-2" />
//                   <strong style={{ color: "#eaf6ff" }}>Scoring System</strong>
//                 </div>
//                 <div style={{ color: "#8ecbff", fontSize: 14 }}>
//                   • 10 XP per correct answer<br />
//                   • 30 bonus XP for perfect score (all questions correct)<br />
//                   • Weekly quizzes help you track progress over time
//                 </div>
//               </div>

//               {loading && (
//                 <div className="text-center mt-3">
//                   <div className="spinner-border text-primary" style={{ width: 24, height: 24 }}>
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                   <div style={{ color: "#8ecbff", fontSize: 14, marginTop: 8 }}>
//                     Loading {selectedProvider} quiz...
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="col-lg-4">
//             <div className="card" style={cardStyle}>
//               <h6 style={{ color: "#eaf6ff", marginBottom: 16 }}>
//                 <Clock size={18} className="me-2" />
//                 Recent Quiz History
//               </h6>
//               <div style={{ maxHeight: 300, overflowY: "auto" }}>
//                 {history.length === 0 ? (
//                   <div style={{ fontSize: 13, color: "#8ecbff", textAlign: "center", padding: "20px 0" }}>
//                     No quiz attempts yet.<br />Take your first quiz to get started!
//                   </div>
//                 ) : (
//                   history
//                     .slice()
//                     .sort((a, b) => (a.takenAt < b.takenAt ? 1 : -1))
//                     .slice(0, 10)
//                     .map((h, index) => (
//                       <div
//                         key={`${h.employeeId}-${h.weekId}-${index}`}
//                         className="d-flex justify-content-between align-items-center py-2 px-2 mb-2"
//                         style={{ 
//                           background: "rgba(255,255,255,0.03)",
//                           borderRadius: 8,
//                           border: "1px solid rgba(130,200,255,0.1)"
//                         }}
//                       >
//                         <div>
//                           <div style={{ fontWeight: 600, color: "#eaf6ff", fontSize: 13 }}>
//                             {h.provider} Quiz
//                           </div>
//                           <div style={{ color: "#8ecbff", fontSize: 12 }}>
//                             {h.correct}/{h.total} correct • {h.actualWeekId || h.weekId}
//                           </div>
//                         </div>
//                         <div style={{ textAlign: "right" }}>
//                           <div style={{ color: "#82c8ff", fontWeight: 600 }}>{h.points} XP</div>
//                           <div style={{ color: "#8ecbff", fontSize: 11 }}>
//                             {h.takenAt ? new Date(h.takenAt).toLocaleDateString() : ""}
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Show quiz questions
//   return (
//     <div className="container-fluid">
//       <div className="row g-3">
//         <div className="col-lg-8">
//           <div className="card" style={cardStyle}>
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <div>
//                 <h5 style={{ margin: 0, color: "#eaf6ff" }}>
//                   {selectedProvider === 'AWS' ? '🚀' : '☁️'} {selectedProvider} Quiz
//                 </h5>
//                 <div style={{ fontSize: 13, color: "#8ecbff", marginTop: 4 }}>
//                   {questions.length} questions • 10 XP per correct + 30 bonus for perfect score
//                 </div>
//               </div>
//               <button 
//                 className="btn btn-outline-secondary btn-sm"
//                 onClick={resetQuiz}
//                 disabled={submitting}
//               >
//                 ← Back to Selection
//               </button>
//             </div>

//             {questions.map((q, idx) => (
//               <div key={idx} style={{ marginBottom: 20 }}>
//                 <div style={{ 
//                   fontWeight: 600, 
//                   marginBottom: 8, 
//                   color: "#eaf6ff",
//                   fontSize: 15
//                 }}>
//                   {idx + 1}. {q.question || q.q}
//                 </div>
//                 <div className="ms-3">
//                   {(q.options || []).map((opt, oi) => (
//                     <label
//                       key={oi}
//                       style={{
//                         display: "block",
//                         fontSize: 14,
//                         cursor: "pointer",
//                         marginBottom: 6,
//                         padding: "8px 12px",
//                         borderRadius: 6,
//                         background: answers[idx] === opt 
//                           ? "rgba(130,200,255,0.2)" 
//                           : "rgba(255,255,255,0.03)",
//                         border: "1px solid " + (answers[idx] === opt 
//                           ? "rgba(130,200,255,0.4)" 
//                           : "rgba(130,200,255,0.1)"),
//                         color: "#eaf6ff"
//                       }}
//                     >
//                       <input
//                         type="radio"
//                         name={`q-${idx}`}
//                         checked={answers[idx] === opt}
//                         onChange={() => pick(idx, opt)}
//                         style={{ marginRight: 8 }}
//                       />
//                       {opt}
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             ))}

//             <div className="mt-4 d-flex justify-content-between align-items-center">
//               <div style={{ color: "#8ecbff", fontSize: 14 }}>
//                 {Object.keys(answers).length}/{questions.length} questions answered
//               </div>
//               <button 
//                 className="btn btn-primary px-4"
//                 onClick={submit} 
//                 disabled={submitting || Object.keys(answers).length !== questions.length}
//                 style={{ borderRadius: 10 }}
//               >
//                 {submitting ? "Submitting..." : "Submit Quiz"}
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-4">
//           <div className="card" style={cardStyle}>
//             <h6 style={{ color: "#eaf6ff" }}>Quiz Progress</h6>
//             <div className="mt-3">
//               <div className="progress mb-3" style={{ height: 8, background: "rgba(255,255,255,0.1)" }}>
//                 <div 
//                   className="progress-bar" 
//                   style={{ 
//                     width: `${(Object.keys(answers).length / questions.length) * 100}%`,
//                     background: "linear-gradient(45deg, #82c8ff, #4da6ff)"
//                   }}
//                 ></div>
//               </div>
//               <div style={{ color: "#8ecbff", fontSize: 13, marginBottom: 16 }}>
//                 {Object.keys(answers).length} of {questions.length} completed
//               </div>

//               <div className="mb-3">
//                 <strong style={{ color: "#eaf6ff", fontSize: 14 }}>Potential Score:</strong>
//                 <div style={{ color: "#82c8ff", fontSize: 16, fontWeight: 600 }}>
//                   {Object.keys(answers).length * 10} XP
//                   {Object.keys(answers).length === questions.length && (
//                     <span style={{ color: "#ffd700" }}> + 30 bonus</span>
//                   )}
//                 </div>
//               </div>

//               <div style={{ 
//                 padding: 12,
//                 background: "rgba(130,200,255,0.1)",
//                 borderRadius: 8,
//                 border: "1px solid rgba(130,200,255,0.2)",
//                 fontSize: 12,
//                 color: "#8ecbff"
//               }}>
//                 💡 <strong>Tip:</strong> Answer all questions correctly to earn the maximum 30 bonus XP!
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// const cardStyle = {
//   borderRadius: 14,
//   background: "rgba(3,19,40,0.95)",
//   border: "1px solid rgba(130,200,255,0.35)",
//   padding: 20,
//   marginBottom: 16,
// };

// // Add CSS for provider cards
// const styles = `
// .quiz-provider-card {
//   padding: 20px;
//   border-radius: 12px;
//   background: rgba(255,255,255,0.04);
//   border: 2px solid rgba(130,200,255,0.2);
//   transition: all 0.3s ease;
//   min-height: 120px;
//   display: flex;
//   align-items: center;
// }

// .quiz-provider-card:hover {
//   background: rgba(130,200,255,0.1);
//   border-color: rgba(130,200,255,0.4);
//   transform: translateY(-2px);
//   box-shadow: 0 8px 25px rgba(130,200,255,0.15);
// }

// .quiz-provider-card:active {
//   transform: translateY(0);
// }
// `;

// // Inject styles
// if (typeof document !== 'undefined') {
//   const styleSheet = document.createElement("style");
//   styleSheet.type = "text/css";
//   styleSheet.innerText = styles;
//   document.head.appendChild(styleSheet);
// }

import React from "react";
import { Hourglass, Sparkles } from "lucide-react";

export default function Quiz() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <Hourglass size={60} color="#82c8ff" />
        </div>

        <h2 style={styles.title}>Quiz Module Coming Soon</h2>

        <p style={styles.subtitle}>
          We're crafting something exciting to test your skills.
        </p>

        <div style={styles.badge}>
          <Sparkles size={18} className="me-2" />
          <span>Launching Soon</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "radial-gradient(circle at top, #001f3f, #000814, #00040f)"
  },
  card: {
    width: "420px",
    textAlign: "center",
    padding: "40px 30px",
    background: "rgba(3,19,40,0.95)",
    border: "1px solid rgba(130,200,255,0.35)",
    borderRadius: "16px",
    backdropFilter: "blur(6px)"
  },
  iconWrapper: {
    marginBottom: 20,
    animation: "pulse 1.5s ease-in-out infinite"
  },
  title: {
    color: "#eaf6ff",
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: 10
  },
  subtitle: {
    color: "#8ecbff",
    fontSize: "15px",
    marginBottom: 25
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 16px",
    borderRadius: 20,
    fontSize: 14,
    color: "#82c8ff",
    background: "rgba(130,200,255,0.15)",
    border: "1px solid rgba(130,200,255,0.35)"
  }
};

// Add subtle animation
const sheet = document.styleSheets[0];
sheet.insertRule(`
@keyframes pulse {
  0% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.08); opacity: 1; }
  100% { transform: scale(1); opacity: 0.9; }
}
`, sheet.cssRules.length);
